var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "actions-collapsed-list" },
    [
      _c(
        "a",
        {
          staticClass: "btn btn-function exit-collapsed-list",
          on: { click: _vm.collapseActions }
        },
        [
          _c("i", {
            staticClass: "glyphicon glyphicon-chevron-left",
            attrs: {
              "aria-hidden": "true",
              "tooltip-placement": "right",
              "uib-tooltip": "Cancel"
            }
          })
        ]
      ),
      _vm._v(" "),
      _vm.user.email !== _vm.currentUserName
        ? _c("div", { staticClass: "action-icon" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-list-function",
                attrs: { disabled: _vm.disabled },
                on: { click: _vm.openDeleteModal }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.bottom.hover",
                      value: _vm.user.hasUser
                        ? {
                            text: _vm.$t("TT_ACTION_REMOVE_USER"),
                            transition: 0
                          }
                        : {
                            text: _vm.$t("TT_ACTION_REMOVE_INVITATION"),
                            transition: 0
                          },
                      expression:
                        "user.hasUser ? {text:$t('TT_ACTION_REMOVE_USER'), transition: 0} :{text:$t('TT_ACTION_REMOVE_INVITATION'), transition: 0}",
                      modifiers: { bottom: true, hover: true }
                    }
                  ],
                  staticClass: "typcn typcn-trash",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "DELETE",
                      expression: "'DELETE'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.user.hasInvite && !_vm.user.hasUser && _vm.user.invite.url
        ? _c("div", { staticClass: "action-icon" }, [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "clipboard",
                    rawName: "v-clipboard",
                    value: { copyText: _vm.user.invite.url },
                    expression: "{ copyText: user.invite.url }"
                  }
                ],
                staticClass: "btn btn-list-function",
                attrs: { disabled: _vm.disabled },
                on: { click: _vm.onCopiedInviteUrl }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.bottom.hover",
                      value: _vm.$t("TT_ACTION_COPY_INVITE"),
                      expression: "$t('TT_ACTION_COPY_INVITE')",
                      modifiers: { bottom: true, hover: true }
                    }
                  ],
                  staticClass: "typcn typcn-code",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "TT_ACTION_COPY_INVITE",
                      expression: "'TT_ACTION_COPY_INVITE'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showDeleteInviteModal
        ? _c(
            "ConfirmationModal",
            {
              attrs: {
                title: _vm.$t("TITLE_DELETE_INVITE"),
                "cancel-button-text": _vm.$t("CANCEL"),
                "confirm-action-text": _vm.$t("DELETE"),
                "show-header-close-button": false,
                "confirm-button-loading": _vm.isDeletePending,
                "cancel-button-disabled": _vm.isDeletePending
              },
              on: { confirm: _vm.deleteInvite, close: _vm.hideModal }
            },
            [
              _c("p", {
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("LABEL_DELETE_INVITE_MODAL_MESSAGE", {
                      userName: _vm.user.name
                    })
                  )
                }
              }),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("LABEL2_DELETE_INVITE_MODAL_MESSAGE")
                  )
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showDeleteUserModal
        ? _c(
            "ConfirmationModal",
            {
              attrs: {
                title: _vm.$t("TITLE_DELETE_USER"),
                "cancel-button-text": _vm.$t("CANCEL"),
                "confirm-action-text": _vm.$t("DELETE"),
                "show-header-close-button": false,
                "confirm-button-loading": _vm.isDeletePending,
                "cancel-button-disabled": _vm.isDeletePending
              },
              on: { confirm: _vm.deleteUser, close: _vm.hideModal }
            },
            [
              _c("p", {
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("LABEL_DELETE_USER_MODAL_MESSAGE", {
                      userName: _vm.user.name
                    })
                  )
                }
              })
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }